/* Tanvika — reviews rail.
 *
 * The rail is a native scroller with CSS scroll-snap; this only wires the
 * arrows to it. Everything works without this file: the rail still scrolls by
 * drag, wheel and keyboard, and the arrows are aria-hidden precisely because
 * they are a convenience over a control that already exists.
 *
 * Arrows are rendered once per slide, matching the reference, but only the
 * on-screen pair is ever visible. They all drive the same rail.
 */
(function () {
  function init(root) {
    var rail = root.querySelector('[data-tv-rail]');
    if (!rail) return;

    function step() {
      var slide = rail.querySelector('.tv-voices__slide');
      if (!slide) return rail.clientWidth;
      // One slide plus the gap. Reading the gap rather than assuming it keeps
      // this correct across the breakpoint, where it changes 2.4rem -> 1.6rem.
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    rail.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-tv-prev]');
      var next = e.target.closest('[data-tv-next]');
      if (!prev && !next) return;
      rail.scrollBy({ left: next ? step() : -step(), behavior: 'smooth' });
      // Don't wait on the scroll event alone to refresh the arrows. It is
      // coalesced or dropped in some embedded webviews, which strands a button
      // greyed out after the rail has already moved.
      sync();
      setTimeout(sync, 450);
    });

    // Grey out the arrows at each end. 2px of slack absorbs the sub-pixel
    // rounding that otherwise leaves the end state one pixel short.
    function sync() {
      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      rail.querySelectorAll('[data-tv-prev]').forEach(function (b) { b.disabled = atStart; });
      rail.querySelectorAll('[data-tv-next]').forEach(function (b) { b.disabled = atEnd; });
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-tv-voices]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-tv-voices]').forEach(init);
  });
})();
